'use client';

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _excluded = ["html", "dangerouslySetInnerHTML", "allowRerender"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _require = require('react'),
  createElement = _require.createElement,
  useEffect = _require.useEffect,
  useRef = _require.useRef;
function DangerouslySetHtmlContent(_ref) {
  var html = _ref.html,
    dangerouslySetInnerHTML = _ref.dangerouslySetInnerHTML,
    allowRerender = _ref.allowRerender,
    rest = _objectWithoutProperties(_ref, _excluded);
  // We remove 'dangerouslySetInnerHTML' from props passed to the div
  var divRef = useRef(null);
  var isFirstRender = useRef(true);
  useEffect(function () {
    if (!html || !divRef.current) throw new Error("html prop can't be null");
    if (!isFirstRender.current) return;
    isFirstRender.current = Boolean(allowRerender);
    var slotHtml = document.createRange().createContextualFragment(html); // Create a 'tiny' document and parse the html string
    divRef.current.innerHTML = ''; // Clear the container
    divRef.current.appendChild(slotHtml); // Append the new content
  }, [html, divRef]);
  return createElement('div', _objectSpread(_objectSpread({}, rest), {}, {
    ref: divRef
  }));
}
module.exports = DangerouslySetHtmlContent;